<template>
<div class="MTeacherView m-agency">
    <!--<div class="m-header" :style="item.welcomecourselist.length?'background:url('+item.welcomecourselist[0].coverurl+');background-repeat:no-repeat;background-size:100% 100%;':''">-->
    <div class="m-header" :style="'background:url('+imgAgency+');background-repeat:no-repeat;background-size:100% 100%;'">
        <div class="top">
            <div class="agency-logo">
                <img class="img" v-lazy="item.teacherinfo.logourl" alt="">
                <span class="blod">{{item.teacherinfo.teachername}}</span>
            </div>
        </div>
        <div class="bottom">
            <div class="box">
                <div class="name">课程数</div>
                <div class="value">{{item.teacherinfo.coursecount}}</div>
            </div>
            <div class="box">
                <div class="name">学生数</div>
                <div class="value">{{item.teacherinfo.studentcount}}</div>
            </div>
        </div>
    </div>
    <div class="m-body">
        <div class="title">TA的课程</div>
        <MCourseList :item="item"></MCourseList>
    </div>
    <div class="serve icon-serve" @click="openService"></div>
    <Popup :pop="service" ref="service">
        <div class="contact">
            <div class="tel">电话：{{item.withinfo.linktel}}</div>
            <div class="email">邮箱：{{item.withinfo.linkemail}}</div>
        </div>
    </Popup>
</div>
</template>

<script>
import {getHostTeacherDetail} from 'api/api'
import {mapActions, mapGetters} from 'vuex'
import MCourseList from 'views/mobile/sort/agency/components/mCourseList'
import Popup from 'views/mobile/components/popup/popup'
import {promiseUrlToQRCode} from 'common/js/tools'
export default {
    name: 'MTeacherView',
    data() {
        return {
            imgAgency: require('@/common/images/msort/img-agency.png'),
            param: {
                hostid: this.$route.query.hostid ? this.$route.query.hostid : '',
                teacherid: this.$route.query.teacherid ? this.$route.query.teacherid : ''
            },
            item: {
                withinfo: {
                    linktel: '',
                    linkemail: ''
                },
                courselist: [],
                teacherinfo: {},
                welcomecourselist: []
            },
            service: {
                url: '',
                title: '',
                tip: [],
                isSave: false
            }
        }
    },
    mounted() {
        if (!this.refresh) {
            this.getView()
        }
    },
    activated() {
       if (this.refresh) {
           this.param.teacherid = this.$route.query.teacherid ? this.$route.query.teacherid : ''
           this.param.hostid = this.$route.query.hostid ? this.$route.query.hostid : ''
           this.getView()
           this.setRefresh(false)
       }
    },
    methods: {
        openService() {
            this.$refs.service.open()
        },
        getView() {
            this.setLoading(true)
            getHostTeacherDetail({
                data: this.param,
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                    let _this = this
                    if (this.item.withinfo.bannerlogourl) {
                        promiseUrlToQRCode(this.item.withinfo.bannerlogourl, this.item.hostinfo.hostlogourl).then(
                            function (data) {
                                _this.service.url = data
                            },
                            function (reason, data) {
                                console.log('二维码生成失败：', reason, data)
                            }
                        )
                    }
                    this.service.tip = [this.item.withinfo.description]
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        MCourseList, Popup
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~views/mobile/sort/agency/agency";
.MTeacherView {
    .m-body{
        .title{
            padding: 0.32rem 0.32rem 0.16rem 0.32rem;
            color: $c-black;
            font-size: 0.28rem;
            font-weight: 600;
            background: $c-white;
        }
    }
}
</style>